import Data from './Data';

const ButtonSidebar = (props) => {
  return <Data {...props} />;
};

export default ButtonSidebar;
